import axios from 'axios';

const API = axios.create({
 // baseURL: 'http://103.102.234.55:8080/api' // Replace with your IP
 baseURL: 'https://advisormitra.com/api'
});
// We can't call a hook directly in a module scope.
// Let's create a wrapper function that will have access to the reset timer.
let resetTimer;
export const setApiResetTimer = (reset) => {
    resetTimer = reset;
};

// Interceptor to reset the timer before each request
API.interceptors.request.use(
    (config) => {
        if (resetTimer) {
            resetTimer();
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

export const getCustomerDetailAgentId = (agentId, reportType) => {
  return API.get('/pdf/customerdetails', {
    params: {
      agentId: agentId,
      reportType: reportType,
    },
  });
};
// src/services/api.js
export const submitFinancialPlan = (planData) => {
  return API.post('/financial-plan/submit', planData, {
    headers: {
      'Content-Type': 'application/json'
    }
  });
};


    export const getFinancialGoals = (customerId) => {
      return API.get(`/customers/${customerId}/financial-goals`, {
        headers: {
          'Content-Type': 'application/json; charset=utf-8'
        }
      });
    };
    

      // Update existing services
    export function  getCustomerForFinancialPlanning  (customerId) {
          return API.get(`/financial-plan/customer/${customerId}`);
    };
    export function submitFormData(formData, token) {
      return API.post('/form-submissions', formData, {
          headers: {
              'Content-Type': 'application/json',
          },
          params: {
            token: token,
          }
      });
    };
export function submitTermInsuranceFormData(formData, token) {
  return API.post(`/form-submissions/term-insurance/${token}`, formData, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
}

export const submitChildEducationForm = (formData) => {
  return API.post('/child-education-form/submit', formData, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

export const submitChildWeddingForm = (formData) => {
  return API.post('/child-wedding-form/submit', formData, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

export const submitHealthInsuranceForm = (formData) => {
  return API.post('/health-insurance-form/submit', formData, {
    headers: {
      'Content-Type': 'application/json',
    }
  });
};

// Fetch all form master entries
export const fetchForms = () => {
  return API.get('/form-master/all');
};

export const getFormMasterList = () => {
  return API.get('/form-links/form-master');
};

export const generateFormLink = (agentId, formId) => {
  return API.post('/form-links/generate', null, {
    params: { agentId, formId },
  });
}
// services/api.js
export const getAgentIdByToken = (token) => {
  return API.get(`/form-links/get-agent-id/${token}`);
};
export const contactUs = (formData) => {
  return API.post('/contact', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
};

export const pricing = (formData) => {
  return API.post('/pricing', formData) ;
};

export const checkDuplicate = (email, phone) => {
  return API.get(`/agents/checkduplicate?email=${encodeURIComponent(email)}&phone=${encodeURIComponent(phone)}`);
};

export const createAgent = (agentData) =>
  API.post('/agents/register', agentData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const createBulkAgents = (agentData) =>
  API.post('/agents/bulkregister', agentData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });

export const getAgentsByOwnerId = (userId) => {
  return API.get(`/agents/owner/${userId}`);
};
export const getAgentByAgentId = (agentId) => {
  return API.get(`/agents/agent/${agentId}`);
};
export const getAgentByAgentIdDownload = (agentId) => {
  return API.get(`/agents/agent/${agentId}`);
};
export const findAgentsWithDetailsByOwnerId = (userId) => {
  return API.get(`/agents/owners/${userId}`);
};

export const getAgentDetailsWithReportCount = () => {
  return API.get('/agents/agent-details-with-report-count'); // Added /api
};

export const getOrganizations = () => {
  return API.get('/organizations');
};

export const getSubscriptionPackages = () => {
  return API.get('/SubscriptionPackage');
};
export const getReferredBy = () => {
  return API.get('/ReferredBy');
};

export const getRoles = () => {
  return API.get('/roles');
};

export const getSubscriptionsByAgentId = (agentId) => {
  return API.get(`/subscriptions/agent/${agentId}`);
};



export const downloaddbPdf = (formData, onProgress) => {
  return API.post('/pdf/downloaddb', formData, {
    responseType: 'blob', // Keep responseType: 'blob' for PDF download
    onDownloadProgress: (progressEvent) => {
      if (onProgress && progressEvent.total) {
        onProgress(progressEvent);
      }
    }
  });
};

export const loginUser = (username, password) => {
  return API.post('/users/login', { username, password });
  
};

export const registerUser = (user) => {
  return API.post('/auth/register', user);
};

export const forgotPassword = (email) => {
  return API.post('/forgot-password', { email });
};

export const changePassword = (userId, oldPassword, newPassword) => {
  return API.post('/users/change-password', {
    id: userId,
    oldPassword,
    newPassword,
  });
};

// Moved to top level
export const getAgentByEmail = (email) => {
  return API.get(`/agents/email/${encodeURIComponent(email)}`);
};
// Fetch last login timestamp for a user by username
export const getLastLogin = (userId) => {
  return API.get(`/users/last-login/${userId}`);
};  
// Fetch report based on agent id 
export const getReportByAgentId = (agentId) => {
  return API.get(`reports/reportdetails/${agentId}`);
};